import { useTranslation } from "react-i18next";
import { Pencil, X } from "lucide-react";

import { Button } from "@/components/ui/button";

interface ProfileDrawerHeaderProps {
  onEdit: () => void;
  onClose: () => void;
}

/**
 * Fixed top bar. Stays outside the scroll region so the drawer's identity and
 * its two escape hatches (edit, close) are always reachable.
 */
export const ProfileDrawerHeader = ({
  onEdit,
  onClose,
}: ProfileDrawerHeaderProps) => {
  const { t } = useTranslation(["common"]);
  return (
    <header className="flex shrink-0 items-center justify-between gap-2 px-4 pt-4 pb-3">
      <h2 className="text-[11px] font-semibold tracking-[0.14em] text-muted-foreground uppercase">
        {t("common:chrome.my_account")}
      </h2>
      <div className="flex items-center gap-1.5">
        <Button
          size="icon-xs"
          variant="secondary"
          onClick={onEdit}
          aria-label={t("common:a11y.edit_profile")}
          className="rounded-full transition-all hover:bg-primary-muted hover:text-primary active:scale-90"
          data-tooltip-id="hrm-tooltip"
          data-tooltip-content={t("common:a11y.edit_profile")}
        >
          <Pencil size={12} strokeWidth={2.5} aria-hidden />
        </Button>
        <Button
          size="icon-xs"
          variant="secondary"
          onClick={onClose}
          aria-label={t("common:a11y.close_profile_drawer")}
          className="rounded-full transition-all hover:bg-primary-muted hover:text-primary active:scale-90"
          data-tooltip-id="hrm-tooltip"
          data-tooltip-content={t("common:buttons.close")}
        >
          <X size={13} strokeWidth={2.75} aria-hidden />
        </Button>
      </div>
    </header>
  );
};
